import React, { useEffect, useState } from "react";
import Header from "../../../components/Header/index";
import { Spin, Tabs } from "antd";
import style from "./Course.module.scss";
import Config from "../../../config";
import { useParams } from "react-router-dom";

const { TabPane } = Tabs;

interface PaneProps {
    title: string;
    url: string;
    key: string;
    closable?: boolean;
}

export default function PageCourse() {
    const { courseVersionCode, courseName } = useParams<{
        courseVersionCode: string;
        courseName: string;
    }>();
    const defaultTabUrl = `${Config.CourseUrl}?customerCode=${
        Config.CustomCode
    }&courseVersionCode=${courseVersionCode}&courseName=${encodeURIComponent(
        courseName!
    )}`;

    useEffect(() => {
        window.addEventListener("message", onMessage);
        return () => window.removeEventListener("message", onMessage);
    }, []);

    const onMessage = (msg: any) => {
        if (msg.data.action === "openPage")
            add(msg.data.id, msg.data.title, msg.data.href);
    };

    const [panes, setPanes] = useState<PaneProps[]>([
        { title: "教学活动", url: defaultTabUrl, key: "1", closable: false }
    ]);

    const [activeKey, setActiveKey] = useState(panes[0].key);

    const onChange = (activeKey: string) => {
        setActiveKey(activeKey);
    };

    const onEdit = (
        targetKey: string | React.MouseEvent<HTMLElement>,
        action: "add" | "remove"
    ) => {
        if (typeof targetKey !== "string") return;

        if (action === "add") {
            ///
        } else {
            remove(targetKey);
        }
    };

    const add = (key: string, title: string, url: string) => {
        setPanes([...panes, { title, url, key }]);
        setActiveKey(key);
    };

    const remove = (targetKey: string) => {
        let lastIndex = 0;
        let activeKey2 = activeKey;

        panes.forEach((pane, i) => {
            if (pane.key === targetKey) {
                lastIndex = i - 1;
            }
        });

        const panes2 = panes.filter(pane => pane.key !== targetKey);

        if (panes2.length && activeKey === targetKey) {
            if (lastIndex >= 0) {
                activeKey2 = panes2[lastIndex].key;
            } else {
                activeKey2 = panes2[0].key;
            }
        }

        setPanes(panes2);
        setActiveKey(activeKey2);
    };

    return (
        <div className={style.root}>
            <Header />

            <div className={style.container}>
                <Tabs
                    hideAdd
                    onChange={onChange}
                    activeKey={activeKey}
                    type="editable-card"
                    onEdit={onEdit}>
                    {panes.map(pane => (
                        <TabPane
                            tab={pane.title}
                            key={pane.key}
                            closable={pane.closable}>
                            <CourseFrame url={pane.url} />
                        </TabPane>
                    ))}
                </Tabs>
            </div>
        </div>
    );
}

interface CourseFrameProps {
    url: string;
}

function CourseFrame({ url }: CourseFrameProps) {
    const [isLoad, setIsLoad] = useState(false);

    function onLoad() {
        setIsLoad(true);
    }

    return (
        <div className={style.frameWrapper}>
            {!isLoad && (
                <div style={{ textAlign: "center", padding: "50px 0" }}>
                    <Spin size="large" className={style.Spin} />
                </div>
            )}
            <iframe
                className={style.iframe}
                src={url}
                frameBorder={0}
                onLoad={onLoad}
            />
        </div>
    );
}
